import { parse } from 'date-fns';

export const getStandardizedDateTimeFromGCalDateTime = (gCalItemDateTime) => {
  if (gCalItemDateTime.date) {
    return new Date(parse(gCalItemDateTime.date, 'yyyy-MM-dd', new Date()));
  } else if (gCalItemDateTime.dateTime) {
    return new Date(gCalItemDateTime.dateTime);
  }
};
